<template>
  <div
    class="text-app-color group mb-10"
    @mouseover.stop.prevent="showInfo(true)"
    @mouseleave.stop.prevent="showInfo(false)"
  >
    <p class="font-bold text-15 leading-normal">{{ userName }}</p>

    <ExpandedTextarea v-if="isEdit">
      <textarea
        ref="textarea"
        v-model="localComment.body"
        maxlength="255"
        rows="2"
        class="w-full outline-none bg-transparent font-normal-important text-15"
        @blur="update"
        @keydown.backspace.stop
        @keydown.enter.exact.prevent.stop="update"
      />
    </ExpandedTextarea>

    <pre v-else class="font-Inter whitespace-pre-line font-normal-important bg-transparent border-none p-0 text-15">{{ localComment.body }}</pre>

    <div class="">
      <div class="flex items-center font-normal-important">
        <p class="text-grey-250 text-13">{{ parseDate(comment.createdAt, 'MM-DD-YYYY hh:mm') }}</p>

        <div
          class="opacity-25 hover:opacity-100 anim-opacity"
          :class="isDarkMode ? 'text-grey-250' : 'text-black-color'"
        >
          <ButtonModule
            v-if="allowEditOrDelete"
            ref="button"
            prefix="icon-delete opacity-0 group-hover:opacity-100"
            class="ml-5"
            @click="remove"
          />
        </div>
        <div class="opacity-25 hover:opacity-100 anim-opacity">
          <ButtonModule
            v-if="allowEditOrDelete"
            ref="button"
            prefix="icon-edit opacity-0 group-hover:opacity-100"
            class="pl-0"
            @click="edit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentService } from '@/services'
import { mapGetters, mapMutations } from 'vuex'
import ExpandedTextarea from '@/components/shared/form-controls/ExpandedTextarea'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { parseDate } from '@/plugins/filters'

export default {
  components: { ExpandedTextarea, ButtonModule },

  props: {
    comment: Object,
    project: Object,
    comments: Array,
    user: Object
  },

  emits: ['remove'],

  data () {
    return {
      localComment: null,
      info: false,
      isEdit: false
    }
  },

  computed: {
    ...mapGetters(['isDarkMode']),

    allowEditOrDelete () {
      return this.localComment.user && this.user && this.localComment.user.profile.userName === this.user.profile.userName
    },

    userName () {
      return this.localComment.user?.profile.firstName || 'Guest'
    }
  },

  created () {
    this.localComment = JSON.parse(JSON.stringify(this.comment))
    this.$nextTick(() => {
      // this.$el.scrollIntoView(false)
    })
  },

  methods: {
    ...mapMutations(['updateComments']),

    remove () {
      if (this.comment.parentId) {
        commentService.delete(this.comment.id).then(() => {
          this.updateComments(this.project.comments.filter(item => item.id !== this.comment.id))
        })
      } else {
        this.$emit('remove', this.comment.id)
      }
    },

    update () {
      this.isEdit = false

      if (this.localComment.body.trim() === '') {
        this.localComment.body = this.comment.body
        return
      }

      if (this.localComment.body !== this.comment.body) {
        commentService.update(this.localComment.id, this.localComment.body)
          .then(() => {
            const comments = this.project.comments
            const comment = comments.find(item => item.id === this.localComment.id)
            comment.body = this.localComment.body
            this.updateComments(comments)
          })
      }
    },

    edit () {
      this.isEdit = true

      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },

    showInfo (value) {
      this.info = value
    },

    parseDate
  }
}
</script>
